export const TITLE_MIN_HEIGHT = '20px';

export const CONTENT_MIN_HEIGHT = '40px';
